var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { BellIcon } from '@heroicons/react/24/outline';
import DocAlertsConfigTab from '@web/components/DocAlerts/DocAlertsConfigTab/DocAlertsConfigTab';
import DocAlertsTab from '@web/components/DocAlerts/DocAlertsTab/DocAlertsTab';
import Tabs from '@web/components/layout/Tabs';
import { BellSettingsIcon } from '@web/components/ui/icons/BellSettingsIcon';
import { Page } from '@web/pages/layout/Page';
import { docAlertsUrl } from '@web/router/urls';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { usePageTitle } from '@web/utility/hooks/usePageTitle';
import { docAlertsActiveTabs } from '@web/utility/tabs';
import { CanAccessToPage } from '@web/utility/wrapper/CanAccess';
import { ScopeUIPageEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
export var DocAlertsView = function () {
    var t = useTranslation().t;
    var _a = useParams().activeTab, activeTab = _a === void 0 ? docAlertsActiveTabs.alerts : _a;
    var navigateTo = useNavigateTo();
    usePageTitle('Document Alerts');
    var tabs = [
        {
            id: docAlertsActiveTabs.alerts,
            name: t('docAlerts.docAlerts'),
            icon: _jsx(BellIcon, { className: "w-5 h-5 inline-block" }),
            Component: DocAlertsTab
        },
        {
            id: docAlertsActiveTabs.configuration,
            name: t('docAlerts.docAlertsConfiguration'),
            icon: _jsx(BellSettingsIcon, { width: "20", height: "20" }),
            Component: DocAlertsConfigTab
        }
    ];
    function onChange(id) {
        navigateTo({ pathname: "".concat(docAlertsUrl, "/").concat(id) });
    }
    return (_jsx(CanAccessToPage, __assign({ scope: ScopeUIPageEnum.PAGE_DOC_ALERTS }, { children: _jsx(Page, { children: _jsx(Tabs, { active: activeTab, tabs: tabs, onChange: onChange }) }) })));
};
